/**
 * The web app entry (web.md §1): styles in the prototype's order, then the app over the engine worker.
 */

import './styles/index.js';
import { mountApp } from './app/mount.js';

const element = document.getElementById('app');
if (element) mountApp(element);
